/**
 * BETA — catch-all + small endpoints (chatbot, comms, public stats).
 */
import { newId, nowIso } from "../uuid.js";

const empty = () => ({ data: [], total: 0 });
const success = () => ({ success: true });

export function register(route) {
  route("GET", "/stats/public", () => ({ pharmacies: 142, transactions: 248000 }));

  route("POST", "/chatbot/conseil", (ctx) => ({
    reponse:
      "Réponse simulée — le chatbot conseil est désactivé en mode démo. Question reçue : " +
      (ctx.body?.question || ""),
    source: "demo",
  }));
  route("POST", "/chatbot/interactions", success);

  // Admin notifs (PHARMAKON-side) — empty for pharmacy demo
  route("GET", "/comms/admin-notifs", () => ({ data: [], total: 0, unread: 0 }));
  route("POST", "/comms/admin-notifs/:id/read", success);
  route("POST", "/comms/admin-notifs/:id/archive", success);
  route("POST", "/comms/admin-notifs/read-all", success);
  route("POST", "/comms/admin-notifs/archive-read", success);
  route("GET", "/comms/admin-notifs/count", () => ({ unread: 0 }));

  // My tickets (pharmacy-side support)
  route("GET", "/comms/my-tickets", (ctx) => {
    const rows = [...(ctx.store.data.tickets || [])];
    const page = Number(ctx.params.page) || 1;
    const limit = Number(ctx.params.limit) || 20;
    const start = (page - 1) * limit;
    return { data: rows.slice(start, start + limit), total: rows.length, page, limit };
  });

  route("POST", "/comms/my-tickets", (ctx) => {
    const body = ctx.body || {};
    const tkt = {
      id: newId("tkt"),
      sujet: body.sujet || "",
      message: body.message || "",
      priorite: body.priorite || "normale",
      statut: "NOUVEAU",
      created_at: nowIso(),
      replies: [],
    };
    ctx.store.data.tickets.unshift(tkt);
    ctx.commit();
    return tkt;
  });

  route("GET", "/comms/my-tickets/:id", (ctx) =>
    ctx.store.data.tickets.find((t) => t.id === ctx.params.id) || null,
  );

  route("POST", "/comms/my-tickets/:id/mark-read", success);

  route("POST", "/comms/my-tickets/:id/reply", (ctx) => {
    const t = ctx.store.data.tickets.find((x) => x.id === ctx.params.id);
    if (!t) return { status: 404, data: { message: "Ticket introuvable" } };
    t.replies.push({
      id: newId("reply"),
      message: ctx.body?.message || "",
      created_at: nowIso(),
      from: "client",
    });
    t.statut = "REPONDU";
    ctx.commit();
    return t;
  });

  // Admin tickets (other side) — empty stubs
  route("GET", "/comms/tickets", empty);
  route("GET", "/comms/tickets/:id", () => ({ data: null }));
  route("POST", "/comms/tickets/:id/reply", success);
  route("POST", "/comms/tickets/:id/statut", success);
  route("POST", "/comms/tickets/:id/mark-read", success);
  route("GET", "/comms/tickets/stats", () => ({ open: 0, closed: 0, replied: 0 }));

  // Broadcasts
  route("GET", "/comms/broadcasts", empty);
  route("POST", "/comms/broadcasts", () => ({ success: true, id: newId("bcast") }));
  route("GET", "/comms/broadcasts/:id", () => ({ data: null }));
  route("POST", "/comms/broadcasts/:id/preview", () => ({ html: "<p>Aperçu en mode démo</p>" }));
  route("POST", "/comms/broadcasts/:id/send", () => ({ success: true, sent_count: 0 }));
}
